import { render, staticRenderFns } from "./pending.vue?vue&type=template&id=767d02d8"
import script from "./pending.vue?vue&type=script&lang=js"
export * from "./pending.vue?vue&type=script&lang=js"
import style0 from "./pending.vue?vue&type=style&index=0&id=767d02d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports